import { datadogRum } from '@datadog/browser-rum';

const datadogInit = () => {
  datadogRum.init({
    // allowedTracingUrls: ['https://alpha.saagas.ai', 'http://localhost', (url) => url.includes('localhost'), (url) => url.includes('alpha.saagas.ai')],
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'saagas-frontend-app',
    env: import.meta.env.VITE_APP_ENVIRONMENT,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input'
  });
  datadogRum.startSessionReplayRecording();
};


export default datadogInit;
